<template>
  <div class="row-9 m-2 d-flex flex-fill scrollable">
    <div class="col-16 scrollable" style="max-height: 100%">
      <nav role="navigation" aria-label="main navigation" class="container nav-container1 overflowing">
        <div class="nav-scroll">
          <ul id="example-1" class="nav-inner">
            <li v-for="(item, index) in sliceSql" :key="index" :index="index" class="nav-item">
              <a v-on:click="showSql($event)" :id="index">{{ item }} ...</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>


<script>
import { mapMutations, mapState } from 'vuex'

let lasActi

export default {
  data: function () {
    return {}
  },
  computed: {
    sliceSql: function () {
      return this.exampleSqls[this.db].map(function (sql) {
        var str_arr = sql.replace(/[\r\n]/g, '').split(' ')
        var str = str_arr.filter(function (item) {
          return item !== ''
        })
        return str.join(' ').slice(0, 40)
      })   
    },
    ...mapState(['curSql', 'db', 'exampleSqls'])
  },
  methods: {
    showSql: function (e) {
      this.setSql(this.exampleSqls[this.db][e.target.id])
      this.activeIndex = e.target.id
      if (lasActi) lasActi.className = 'nav-item'
      e.target.parentNode.className = 'nav-item active'
      lasActi = e.target.parentNode
    },
    ...mapMutations(['setSql'])
  }
}
</script>